import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { ModelPropertiesParser } from '../commons/modelPropertiesParser';
import { formatModelDateValue, getCountdownRemainingMs } from '../commons/modelDateFormat';
import commaNumber from 'comma-number';

const ExternalComponent = (props) => {
  const { layoutItem, workflowData, companyDetails } = props
  const containerRef = useRef(null);
  let htmlTagEditor = layoutItem && layoutItem.itemProperties && layoutItem.itemProperties.htmlEditorContent
  let cssEditorContent = layoutItem && layoutItem.itemProperties && layoutItem.itemProperties.cssEditorContent
  const enableCommaSep = layoutItem && layoutItem.itemProperties && layoutItem.itemProperties.externalComponentConfig && layoutItem.itemProperties.externalComponentConfig.enableCommaSep

  let replacedHtml = (htmlTagEditor || '').replace(/\{\{(.*?)\}\}/g, (match, key) => {
    key = key.trim();
    let originalVal
    try {
      originalVal = ModelPropertiesParser(match, workflowData)
      // Format dates the same way PrintText / rich text do: date-time is shown
      // in the company/local timezone, a date-only value is shown as-is.
      originalVal = formatModelDateValue(originalVal, companyDetails)
    } catch (e) {
      // A missing/null nested property (e.g. orderdetails is null) must never
      // break the rendered HTML — resolve that placeholder to empty instead.
      originalVal = ''
    }
    if (enableCommaSep) {
      if (originalVal !== null && originalVal !== undefined) {

        if (!isNaN(originalVal)) {

          originalVal = commaNumber(originalVal)


        }
      }
    }

    return originalVal ? originalVal : "";
  });

  // The countdown placeholder ({{...[countdownComponent(Rich)]}}) resolves to an
  // inert <span data-date(-rich)="..." iscountdown...> here (unlike rich text,
  // which turns it into a live <Countdown> via html-to-react). Drive those spans
  // with the exact same logic so the timer works in the external component too.
  useEffect(() => {
    const root = containerRef.current;
    if (!root) return undefined;
    const nodes = root.querySelectorAll('[data-date], [data-date-rich]');
    const intervals = [];
    nodes.forEach((node) => {
      const target = node.getAttribute('data-date') || node.getAttribute('data-date-rich');
      if (!target) return;
      const tick = () => {
        const total = getCountdownRemainingMs(target);
        if (total <= 0) {
          node.textContent = 'Expired';
          return true;
        }
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
        const days = Math.floor(total / (1000 * 60 * 60 * 24));
        const parts = [];
        if (days > 0) parts.push(days + 'd');
        if (hours > 0 || parts.length > 0) parts.push(hours + 'h');
        if (minutes > 0 || parts.length > 0) parts.push(minutes + 'm');
        parts.push(seconds + 's');
        node.textContent = parts.join(' ');
        return false;
      };
      if (tick()) return;
      const id = setInterval(() => { if (tick()) clearInterval(id); }, 1000);
      intervals.push(id);
    });
    return () => intervals.forEach(clearInterval);
  }, [replacedHtml]);

  return (
    <div className="html-preview">
      <style>
        {`
      .html-preview ${cssEditorContent || ""}
    `}
      </style>
      <div ref={containerRef} dangerouslySetInnerHTML={{ __html: replacedHtml }} />
    </div>
  );
}

const mapStateToProps = (state) => {
  const cd = state.getIn(['company', 'details']);
  return {
    companyDetails: cd && cd.toJS ? cd.toJS() : cd
  };
};

export default connect(mapStateToProps)(ExternalComponent);
